module.exports = __webpack_public_path__ + "img/majianbo.321c551d.jpg";